import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { setCache, getCache } from "../util/Cache";
import logo from "../assets/image/pdam.png";
// import { post_user_login } from "../controller/Login";

export default function LoginPage2() {
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({
    email: "",
    password: "",
    remember: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange =
    (field: keyof any) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = field === "remember" ? e.target.checked : e.target.value;
      setForm((prev : any) => ({ ...prev, [field]: value }));
    };

  const fetchUser = async () => {
    const myHeaders = new Headers();

    const formdata = new FormData();
    formdata.append("username_email", form.email);
    formdata.append("password", form.password);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow" as RequestRedirect
    };

    return await fetch( process.env.REACT_APP_API_URL + "/account/auth/login", requestOptions)
      .then((response) => response.json())
      .then((result) => result)
      .catch((error) => { return { status : 500, error } });
  } 

  const handleSubmit = async() => { 
    setError(null);
    if (!form.email || !form.password) {
      setError('Email dan password wajib diisi');
      return;
    }

    setLoading(true);
    try {
      const res = await fetchUser();
      if (!res || res.status !== 200 || !res.data) {
        setError(res.message || 'Login gagal');
        return;
      }
      await setCache('current_user', res.data);
      navigate("/", { replace: true });
    } catch (err: any) {
      setError(err?.message || 'Terjadi kesalahan');
    } finally {
      setLoading(false);
    }
  };

  const checkUserDashboard = async () => {
    try {
      const data = await getCache("current_user");
      // kalo data ada (udah login) -> langsung ke home
      if (data && (data.username || data.nama)) {
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleUser = async () => {
    await checkUserDashboard();
  }
  
  useEffect(() => { handleUser(); }, []);

  return (
    <div className="min-h-screen w-full flex bg-white">
      <div className="w-full lg:w-1/2 flex flex-col justify-between px-8 sm:px-16 py-10">
        <div />

        <div className="w-full max-w-sm mx-auto">
          {/* Header khusus mobile: logo + nama sistem (di desktop tampil di panel kanan) */}
          <div className="lg:hidden mb-10 flex flex-col items-center text-center">
            <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-white p-3 shadow-lg ring-4 ring-sky-100">
              <img
                src={logo}
                className="h-full w-full object-contain"
                alt="Logo PERUMDAM Tirta Moolango"
              />
            </div>
            <p className="text-base font-bold leading-snug text-sky-900">
              Sistem Informasi Kepegawaian PERUMDAM Tirta Moolango
            </p>
          </div>

          <div className="hidden lg:flex items-center gap-3 mb-16">
            {/* <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-purple-700 flex items-center justify-center">
              <div className="w-3 h-3 rounded-full bg-white" />
            </div> */}
          </div>

          <h1 className="text-3xl font-semibold text-gray-900 mb-2">Halaman Masuk</h1>
          <p className="text-gray-500 mb-8">Masukkan Login data anda</p>
          {error && (
            <div role="alert" aria-live="polite" className="mb-4 rounded-md bg-rose-50 border border-rose-100 px-4 py-2 text-sm text-rose-700">
              {error}
            </div>
          )}

          <form className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                Email
              </label>
              <input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange("email")}
                className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1.5">
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••••••"
                  value={form.password}
                  onChange={handleChange("password")}
                  className="w-full rounded-lg border border-gray-300 px-4 py-2.5 pr-10 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((s) => !s)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {/* <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={form.remember}
                  onChange={handleChange("remember")}
                  className="w-4 h-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
                />
                Remember for 30 days
              </label>
              <a href="#" className="text-sm font-medium text-purple-600 hover:text-purple-700">
                Forgot password
              </a>
            </div> */}

            <button
              type="submit"
              disabled={loading}
              className={`w-full rounded-lg ${loading ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'} transition-colors text-white font-medium py-2.5 text-sm`}
              onClick={(e) => { e.preventDefault(); handleSubmit(); }}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>

            {/* <button
              type="button"
              className="w-full flex items-center justify-center gap-2 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <GoogleIcon />
              Sign in with Google
            </button> */}
          </form>

          {/* <p className="mt-8 text-center text-sm text-gray-600">
            Don&apos;t have an account? {" "}
            <a href="#" className="font-medium text-purple-600 hover:text-purple-700">
              Sign up
            </a>
          </p> */}
        </div>

        <p className="text-xs text-gray-400">© Perumdam Tirta Moolango & Bacarina.dev 2026</p>
      </div>

      <div className="relative hidden lg:flex w-1/2 min-h-screen overflow-hidden bg-gradient-to-br from-sky-700 via-cyan-600 to-blue-900 items-center justify-center p-10">
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-white/10 blur-sm" />
        <div className="absolute -bottom-32 -left-24 h-[28rem] w-[28rem] rounded-full bg-cyan-300/20" />
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, white 0 2px, transparent 3px), radial-gradient(circle at 70% 65%, white 0 1px, transparent 2px)", backgroundSize: "90px 90px, 55px 55px" }} />
        <div className="relative z-10 max-w-md text-center text-white">
          <div className="mx-auto mb-8 flex h-28 w-28 items-center justify-center rounded-full bg-white/95 p-4 shadow-2xl ring-8 ring-white/20">
            <img
              src="https://web.tirtamoolango.co.id/images/pdam.png"
              className="h-full w-full object-contain"
              alt="Logo PERUMDAM Tirta Moolango"
            />
          </div>
          <h2 className="text-3xl font-bold tracking-tight">Sistem Informasi Kepegawaian PERUMDAM Tirta Moolango</h2>
          {/* <p className="mt-4 text-base leading-relaxed text-cyan-50">
            
          </p> */}
        </div>
      </div>
    </div>
  );
}

function GoogleIcon(): React.ReactElement {
  return (
    <svg className="w-4 h-4" viewBox="0 0 24 24">
      <path
        fill="#4285F4"
        d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.88c2.27-2.09 3.54-5.17 3.54-8.82z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.88-3c-1.08.72-2.45 1.16-4.05 1.16-3.11 0-5.75-2.1-6.69-4.93H1.29v3.09C3.26 21.3 7.31 24 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M5.31 14.32c-.24-.72-.38-1.49-.38-2.32s.14-1.6.38-2.32V6.59H1.29A11.96 11.96 0 000 12c0 1.93.46 3.76 1.29 5.41l4.02-3.09z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.94 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.59l4.02 3.09c.94-2.83 3.58-4.93 6.69-4.93z"
      />
    </svg>
  );
}